export enum SiteIdeaStatus {
  SiteIdeaActive = 'SiteIdeaActive',
  SiteIdeaDormant = 'SiteIdeaDormant',
  SiteIdeaClosed = 'SiteIdeaClosed',
}
